import {
  hasCompleteQueryData,
  throwOnQueryError,
} from 'ZalamoLibrary/src/lib/core/graphql/complete-query-data';

import { combineLatest, filter, map, pipe, pluck, switchMap } from 'rxjs';

import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MineWallGQL, UserWallEventType } from './graphql';
import { DateTime } from 'luxon';

import { environment } from '../../../environments/environment';
import { OrganizationService } from 'ZalamoLibrary/src/lib/core/organizations/organization.service';
import { GetMineDetailsGQL } from '../../../graphql';
import { Title } from '@angular/platform-browser';

import { OrganizationDetailsService } from 'ZalamoLibrary/src/lib/core/organizations/organization-details.service';

@Component({
  selector: 'app-photographer-home',
  templateUrl: './photographer-home.component.html',
  styleUrls: ['./photographer-home.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PhotographerHomeComponent implements OnInit {
  entries$ = this.mineWallGQL
    .watch({
      variables: {
        date: Math.round(DateTime.now().toSeconds()),
        offset: 0,
        limit: 50,
      },
    })
    .valueChanges.pipe(
      throwOnQueryError,
      filter(hasCompleteQueryData),
      map((result) => result.data['getMineWallHistory']),
      switchMap((mineHistory) =>
        combineLatest([
          this.organizationService
            .getCurrentOrganization()
            .pipe(
              switchMap((organizationId) =>
                this.getMineSubdomainGQL
                  .fetch({ variables: { organizationId } })
                  .pipe(pluck('data', 'me', 'organization')),
              ),
            ),
          this.organizationDetailsService.flags$,
        ]).pipe(
          map(([{ created }, flags]) => {
            mineHistory = [...mineHistory];
            // mineHistory.push();
            mineHistory.push({
              time: created,
              author: '0',
              details: '{"publicSessions":true}',
              userEventId: null,
              event: UserWallEventType.ZalamoWelcomeMessage,
            });
            return mineHistory.filter(({ event }) => {
              if (
                event === UserWallEventType.OrderPlaced &&
                (flags?.hideOrders || flags?.hideRevenue)
              ) {
                return false;
              }
              return true;
            });
          }),
        ),
      ),
    );
  isDev = !environment.production;

  constructor(
    private mineWallGQL: MineWallGQL,
    private getMineSubdomainGQL: GetMineDetailsGQL,
    private organizationService: OrganizationService,
    private organizationDetailsService: OrganizationDetailsService,
    private title: Title,
  ) {
    title.setTitle('Ostatnie wydarzenia');
  }

  ngOnInit(): void {}

  test() {
    console.log('test');
  }
}
